import React from "react";
import ButtonTransitionIntoCalc from "./ButtonForCalc";

const CaseDetails = ( {data} ) => {
    console.log(data)
    return(
        <div className="flex md:flex-row flex-col py-5 lg:px-4 md:px-3 p-5 lg:gap-24 md:gap-20 lg:justify-center 
                md:justify-between leading-tight rounded-3xl" style={{backgroundColor: data.bg_color}}
            >
            <div className="flex flex-col lg:w-[524px] md:w-[320px] md:max-w-full max-w-[480px] w-full gap-7 
                    justify-between md:mx-0 mx-auto"
                >
                {/* Описание */}
                <div className="flex flex-col p-6 rounded-3xl md:gap-20 gap-4" 
                        style={{backgroundColor: data.card.bg_color}}
                    >
                    <div className="flex flex-col">
                    <span className="md:text-[28px] text-[22px] font-medium">
                        {data.card.title.map((title, index) => (
                            <span key={index} style={{ color: title.text_color }}>
                                {title.text}{index < data.card.title.length - 1 ? ' ' : ''}
                            </span>
                        ))}
                    </span>
                    </div>
                    <div className="flex md:flex-row flex-col-reverse items-end md:gap-0 gap-3">
                        <span className="font-medium md:text-[18px] text-[16px]" 
                                style={{color: data.card.description_color}}
                            >
                            {data.card.description}
                        </span>
                        <img className="rounded-2xl w-[100px]" src={data.card.image} alt=""/>
                    </div>
                </div>
                {/* Карточки с этапами для мобалки */}
                <div className="md:hidden flex flex-col gap-7">
                    {
                        data.stage_cards.map( (stage_cards, index) => (
                            <div className="p-6 flex flex-col rounded-3xl h-fit justify-between gap-20" 
                                    style={{backgroundColor: stage_cards.bg_color}}
                                >
                                <div className="triangle"></div>

                                {/* Стрелочка и индекс */}
                                <div className="flex justify-between z-10">
                                    <img className="h-6 p-0.5 w-fit" src={stage_cards.arrow} alt=""/>
                                    <span className="font-medium text-[20px] p-3 border-solid border-2 rounded-full" 
                                            style={{color: stage_cards.index_color, borderColor: stage_cards.index_border_color }}
                                        >
                                        {stage_cards.index}
                                    </span>
                                </div>
                                {/* Текст */}
                                <div className="flex flex-col gap-6">
                                    {/* Большой текст */}
                                    <div className="flex flex-col">
                                        <span className="font-medium md:text-[20px] text-[22px]" 
                                                style={{ color: stage_cards.title.text_color }}
                                            >
                                            {
                                                stage_cards.title.map((title, index) => (
                                                    <span key={index} style={{ color: title.text_color }}>
                                                        {title.text}{index < stage_cards.title.length - 1 ? ' ' : ''}
                                                    </span>
                                                ))
                                            }
                                        </span>
                                    </div>
                                    {/* Маленький текст */}
                                    <span className="font-medium text-[14px]" style={{color: stage_cards.description_color}}>
                                        {stage_cards.description}
                                    </span>
                                </div>
                            </div>
                        ))
                    }
                </div>
                {/* Красный текст */}
                <div className="flex flex-col gap-10">
                    {
                        data.red_text_about_delivery.map ( (red_text_about_delivery, index) =>(
                            <div className="flex flex-col"> 
                                <span className="font-medium md:text-[64px] text-[48px]" 
                                        style={{color: red_text_about_delivery.bigtext_color}}
                                    >
                                    {red_text_about_delivery.bigtext}
                                </span>
                                <span className="font-meduim text-[16px]" 
                                        style={{color: red_text_about_delivery.smalltext_color}}
                                    >
                                    {red_text_about_delivery.smalltext}
                                </span>
                            </div>
                        ))
                    }
                </div>
                <ButtonTransitionIntoCalc data = {data}/>
            </div>
            {/* Карточки с этапами */}
            <div className="md:flex hidden md:flex-col md:w-[320px] gap-6">
                {
                    data.stage_cards.map( (stage_cards, index) => (
                        <div className="p-6 flex flex-col rounded-3xl min-h-[320px] justify-between" 
                                style={{backgroundColor: stage_cards.bg_color}}
                            >
                            <div className="triangle"></div>

                            {/* Стрелочка и индекс */}
                            <div className="flex justify-between z-10 mb-16">
                                <img className="h-6 p-0.5 w-fit" src={stage_cards.arrow} alt=""/>
                                <span className="font-medium text-[20px] p-3 border-solid border-2 rounded-full" 
                                        style={{color: stage_cards.index_color, borderColor: stage_cards.index_border_color }}
                                    >
                                    {stage_cards.index}
                                </span>
                            </div>
                            {/* Текст */}
                            <div className="flex flex-col gap-4">
                                {/* Большой текст */}
                                <div className="flex flex-col">
                                    <span className="font-medium md:text-[20px] text-[16px]" 
                                            style={{ color: stage_cards.title.text_color }}
                                        >
                                        {
                                            stage_cards.title.map((title, index) => (
                                                <span key={index} style={{ color: title.text_color }}>
                                                    {title.text}{index < stage_cards.title.length - 1 ? ' ' : ''}
                                                </span>
                                            ))
                                        }
                                    </span>
                                </div>
                                {/* Маленький текст */}
                                <span className="font-medium text-[14px]" style={{color: stage_cards.description_color}}>
                                    {stage_cards.description}
                                </span>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};
export default CaseDetails;